// Theme.js
import { createTheme } from "@mui/material/styles";
import { createPalette } from './create-palette';
import { createComponents } from './create-components';
import { createShadows } from './create-shadows';
import { createTypography } from './create-typography';

const CreateTheme = (direction = "ltr", lang = "fa") => {
  const palette = createPalette();
  const components = createComponents({ palette });
  const shadows = createShadows();
  const typography = createTypography(lang); // ✅ use lang here

  return createTheme({
    direction,
    components,
    palette,
    shadows,
    shape: {
      borderRadius: 8
    },
    typography
  });
};

export default CreateTheme;
